import { useCookies } from 'vue3-cookies';
const { cookies } = useCookies();
const expireTime = 1000 * 60 * 60 * 24 * 3;
export default {
  setStore(state, store = {}) {
    if (state.storeList.length > 0) {
      const nested = state.storeList.filter(
        (item) => item.storeNo === store.storeNo
      );
      if (nested.length === 0) state.storeList = [store, ...state.storeList];
    } else {
      state.storeList = [store];
    }

    // localStorage.setItem('store', JSON.stringify(store));
    // cookies.set('store', JSON.stringify(store, expireTime, '/'));
  },
  setProduct(state, product = {}) {
    if (state.productList.length > 0) {
      const nested = state.productList.filter(
        (item) => item.productNo === product.productNo
      );
      if (nested.length === 0)
        state.productList = [product, ...state.productList];
    } else {
      state.productList = [product];
    }
  },

  setRecentStoreInfo(state, store) {
    state.storeInfo = store;
  },

  setAddress(
    { state },
    address = [
      {
        address: '',
        addressDetail: '',
        latitude: 0,
        longitude: 0
      }
    ]
  ) {
    cookies.set('address', JSON.stringify(address), expireTime, '/');
  }
};
